import Field from "@hudson/ui/components/FormFields/Field";
import Select from "@hudson/ui/components/FormFields/Select";
import { useFormContext } from "@hudson/ui/components/ReactHookForm";
import { useEffect, useState } from "react";

function Expiration({
  className = "",
  errorMessage,
  fieldName,
  label,
}: {
  className?: string;
  errorMessage: string;
  fieldName: string;
  label: string;
}): JSX.Element | null {
  const { getValues } = useFormContext();
  const [month, setMonth] = useState<string>();
  const [year, setYear] = useState<string>();
  const currentYear = new Date().getFullYear();
  const years = Array.from([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], (v, k) => String(k + currentYear));
  const months = Array.from([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], (v, k) =>
    String(v).padStart(2, "0"),
  );

  // Default the internal expiration value on initial load.
  useEffect(() => {
    const date = getValues()[fieldName];
    if (date && !month && !year) {
      setMonth(date.slice(0, 2));
      setYear(date.slice(-4));
    }
  }, []);

  return (
    <Field
      className={className}
      errorMessage={errorMessage}
      fieldControl={(value, parentOnChange, inError, onBlur) => (
        <div className="flex items-center gap-x-4">
          <Select
            autoComplete="cc-exp-month"
            blankName="MM"
            className=""
            inError={inError}
            onBlur={onBlur}
            onChange={function (v) {
              setMonth(v);
              parentOnChange(`${v}${year || "    "}`);
            }}
            required={true}
            value={String(value).slice(0, 2)}
            values={months}
          />

          <Select
            autoComplete="cc-exp-year"
            blankName="YYYY"
            className=""
            inError={inError}
            onBlur={onBlur}
            onChange={function (v) {
              setYear(v);
              parentOnChange(`${month || "  "}${v}`);
            }}
            required={true}
            value={String(value).slice(-4)}
            values={years}
          />
        </div>
      )}
      fieldName={fieldName}
      fieldValidations={{
        required: errorMessage,
        validate: {
          validDate: function (v) {
            const value = v || "";
            if (!value || value.trim() == "-" || value.trim() == "--") return true;

            const year = value.slice(-4),
              month = value.slice(0, 2),
              currentYear = new Date().getFullYear();
            const valid =
              value.length === 6 &&
              (Number(year) > currentYear ||
                (Number(year) == currentYear && Number(month) >= new Date().getMonth() + 1));
            return valid || errorMessage;
          },
        },
      }}
      label={label}
      validateOnBlur={() => !!(month && year)}
    />
  );
}

export default Expiration;
